import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Text } from 'react-orange-ui';

import Contact from '../../Contact/Contact';
import WordingService from '../../../services/WordingService';

const Container = styled.div`
  margin: 1rem 0;
`;

const ContactList = ({ contacts }) => {
  const contactsEl = contacts.map((contact, index) => (
    <Contact
      id={`contact__${index + 1}`}
      key={contact.contactId}
      className={contact.contactType.toLowerCase() === 'm' ? 'mobile' : 'mail'}
      contact={contact}
      caption={contact.contactType.toLowerCase() === 'm' ? WordingService.getWording('caption', 'contactMobile') : WordingService.getWording('caption', 'contactMail')}
    />
  ));

  return (
    <Container>
      <Text id="contact-list" size="l" bold>
        {WordingService.getWording('caption', 'yourContactWays')}
      </Text>
      {contactsEl}
    </Container>
  );
};

ContactList.propTypes = {
  /** All user contacts ways state */
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      contactData: PropTypes.string,
      contactView: PropTypes.string,
      contactType: PropTypes.string,
      contactId: PropTypes.string,
    }),
  ).isRequired,
};

export default ContactList;
